/* eslint-disable jsx-a11y/alt-text */
import React from 'react'
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
} from '@react-pdf/renderer'
import dayjs from 'dayjs'
import logoPng from './logo-horizontal.png'

const teal = '#2a9d8f'
const darkText = '#1a1a1a'
const gray = '#555'
const lightGray = '#e0e0e0'

const styles = StyleSheet.create({
  page: {
    fontFamily: 'Helvetica',
    fontSize: 10,
    color: darkText,
    paddingHorizontal: 40,
    paddingVertical: 32,
    backgroundColor: '#ffffff',
    justifyContent: 'space-between',
  },
  content: {
    flex: 1,
  },

  // Header
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 16,
    paddingBottom: 12,
    borderBottomWidth: 2,
    borderBottomColor: teal,
  },
  logoBlock: {
    width: 120,
  },
  logoImage: {
    width: 160,
    height: 40,
  },
  headerRight: {
    textAlign: 'right',
    fontSize: 9,
    color: gray,
    maxWidth: 350,
  },

  // Title
  titleSection: {
    alignItems: 'center',
    marginBottom: 16,
  },
  title: {
    fontSize: 14,
    fontFamily: 'Helvetica-Bold',
    letterSpacing: 0.5,
  },

  // Info grid
  infoRow: {
    flexDirection: 'row',
    marginBottom: 12,
    borderBottomWidth: 1,
    borderBottomColor: lightGray,
    paddingBottom: 10,
  },
  infoCell: {
    flex: 1,
  },
  infoLabel: {
    fontSize: 8,
    color: gray,
    marginBottom: 2,
  },
  infoValue: {
    fontSize: 11,
    fontFamily: 'Helvetica-Bold',
  },

  // Sections
  sectionTitle: {
    fontSize: 13,
    fontFamily: 'Helvetica-Bold',
    marginTop: 20,
    marginBottom: 10,
  },

  // Table
  tableHeader: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: darkText,
    paddingBottom: 4,
    marginBottom: 4,
  },
  tableRow: {
    flexDirection: 'row',
    paddingVertical: 5,
    borderBottomWidth: 0.5,
    borderBottomColor: lightGray,
  },
  tableHeaderText: {
    fontSize: 9,
    color: gray,
  },
  tableCell: {
    fontSize: 10,
  },

  // Column widths
  colNome: {
    flex: 1,
  },
  colPaciente: {
    flex: 1,
    paddingHorizontal: 10,
  },
  pacientesChips: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'flex-start',
  },
  pacienteChip: {
    fontSize: 8,
    color: gray,
    backgroundColor: '#eeeeee',
    borderRadius: 8,
    paddingHorizontal: 6,
    paddingVertical: 3,
    marginRight: 4,
    marginBottom: 4,
    maxWidth: '100%',
  },
  colQtd: {
    width: 40,
    textAlign: 'center',
  },
  colUnitario: {
    width: 90,
    textAlign: 'right',
  },
  colValor: {
    width: 90,
    textAlign: 'right',
  },
  colCpf: {
    width: 120,
    textAlign: 'left',
  },

  // Totals
  totalContainer: {
    marginTop: 24,
    padding: 14,
    backgroundColor: '#f7faf9',
    borderWidth: 1,
    borderColor: '#d6e8e5',
    borderRadius: 6,
  },
  resumoTitle: {
    fontSize: 10,
    color: teal,
    fontFamily: 'Helvetica-Bold',
    letterSpacing: 0.6,
    marginBottom: 8,
  },
  resumoDivider: {
    borderTopWidth: 1,
    borderTopColor: lightGray,
    marginVertical: 7,
  },
  formasPagamentoTitle: {
    fontSize: 8,
    color: gray,
    fontFamily: 'Helvetica-Bold',
    letterSpacing: 0.4,
    marginBottom: 3,
  },
  pagamentoRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingVertical: 4,
  },
  pagamentoLabel: {
    fontSize: 9,
    color: gray,
  },
  pagamentoValue: {
    fontSize: 10,
    fontFamily: 'Helvetica-Bold',
    color: darkText,
    width: 110,
    textAlign: 'right',
  },
  totalPagarRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: 3,
    paddingHorizontal: 10,
    paddingVertical: 9,
    backgroundColor: '#e5f4f1',
    borderRadius: 4,
  },
  totalPagarLabel: {
    fontSize: 11,
    color: teal,
    fontFamily: 'Helvetica-Bold',
  },
  totalPagarValue: {
    fontSize: 15,
    fontFamily: 'Helvetica-Bold',
    color: teal,
    width: 120,
    textAlign: 'right',
  },

  // Footer
  footer: {
    marginTop: 32,
    paddingTop: 8,
    borderTopWidth: 1,
    borderTopColor: lightGray,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  footerText: {
    fontSize: 8,
    color: gray,
  },
})

export default function PdfProposta({
  proposta = '',
  contratante = '',
  suite = '',
  checkIn = '',
  checkOut = '',
  dependentes = [],
  pacotes = [],
  terapias = [],
  suplementos = [],
  adicionais = [],
  vendas = [],
  formasPagamento = [],
  totalEstornado = 0,
  desconto = 'R$ 0,00',
  caucao = '',
  subTotal = '',
  total = '',
  observacoes = '',
}) {
  const totalPago = formasPagamento.reduce(
    (totalForma, formaPagamento) =>
      totalForma + Number(formaPagamento?.vlPago || 0),
    0,
  )
  const valorEstornado = Number(totalEstornado || 0)
  const valorPagoLiquido = Math.max(0, totalPago - valorEstornado)
  const observacoesPdf = (observacoes || '')
    .normalize('NFKD')
    .replace(/[^\x20-\x7EÀ-ÿ\r\n]/g, '')

  console.log('observacoesPdf', observacoesPdf)

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.content}>
          {/* Header */}
          <View style={styles.header}>
            <View style={styles.logoBlock}>
              <Image src={logoPng} style={styles.logoImage} />
            </View>
            <View style={styles.headerRight}>
              <Text> Dr. Édio Schaurich - CRM:</Text>
              <Text>
                Rua Buarque de Macedo, 1030/1000 - Progresso, Montenegro - RS
              </Text>
            </View>
          </View>

          {/* Title */}
          <View style={styles.titleSection}>
            <Text style={styles.title}></Text>
          </View>

          {/* Info row 1 */}
          <View style={styles.infoRow}>
            <View style={styles.infoCell}>
              <Text style={styles.infoLabel}>Proposta</Text>
              <Text style={styles.infoValue}>{proposta}</Text>
            </View>
            <View style={styles.infoCell}>
              <Text style={styles.infoLabel}>Suíte</Text>
              <Text style={styles.infoValue}>{suite}</Text>
            </View>
          </View>

          {/* Info row 2 */}
          <View
            style={
              observacoes
                ? styles.infoRow
                : [
                    styles.infoRow,
                    { borderBottomWidth: 2, borderBottomColor: teal },
                  ]
            }
          >
            <View style={{ flex: 2 }}>
              <Text style={styles.infoLabel}>Contratante</Text>
              <Text style={styles.infoValue}>{contratante}</Text>
            </View>
            <View style={styles.infoCell}>
              <Text style={styles.infoLabel}>Check-in</Text>
              <Text style={styles.infoValue}>{checkIn}</Text>
            </View>
            <View style={styles.infoCell}>
              <Text style={styles.infoLabel}>Check-out</Text>
              <Text style={styles.infoValue}>{checkOut}</Text>
            </View>
          </View>
          {observacoes && (
            <View
              style={
                observacoes
                  ? [
                      styles.infoRow,
                      { borderBottomWidth: 2, borderBottomColor: teal },
                    ]
                  : styles.infoRow
              }
            >
              <View style={{ flex: 2 }}>
                <Text style={styles.infoLabel}>Observações</Text>

                {observacoesPdf.split('\n').map((linha, index) => (
                  <Text
                    key={index}
                    style={{
                      fontSize: 11,
                      fontFamily: 'Helvetica',
                      marginBottom: 2,
                    }}
                  >
                    {linha}
                  </Text>
                ))}
              </View>
            </View>
          )}

          {/* Dependentes */}
          {dependentes.length > 0 && (
            <>
              <Text style={styles.sectionTitle}>Dependentes</Text>
              <View style={styles.tableHeader}>
                <Text style={[styles.tableHeaderText, styles.colNome]}>
                  Nome
                </Text>
                <Text style={[styles.tableHeaderText, styles.colCpf]}>CPF</Text>
              </View>
              {dependentes.map((item, i) => (
                <View key={i} style={styles.tableRow}>
                  <Text style={[styles.tableCell, styles.colNome]}>
                    {item?.[1]}
                  </Text>
                  <Text style={[styles.tableCell, styles.colCpf]}>
                    {item?.[2]}
                  </Text>
                </View>
              ))}
            </>
          )}

          {/* Pacotes */}
          {pacotes.length > 0 && (
            <>
              <Text style={styles.sectionTitle}>Pacotes</Text>
              <View style={styles.tableHeader}>
                <Text style={[styles.tableHeaderText, styles.colNome]}>
                  Pacote
                </Text>
                <Text style={[styles.tableHeaderText, styles.colPaciente]}>
                  Pacientes
                </Text>
                <Text style={[styles.tableHeaderText, styles.colValor]}>
                  Valor
                </Text>
              </View>
              {pacotes.map((r, i) => (
                <View key={i} style={styles.tableRow} wrap={false}>
                  <Text style={[styles.tableCell, styles.colNome]}>
                    {r.nome}
                  </Text>
                  <View style={[styles.colPaciente, styles.pacientesChips]}>
                    {(r.pacientes || []).map((nome, index) => (
                      <Text key={index} style={styles.pacienteChip}>
                        {nome}
                      </Text>
                    ))}
                  </View>
                  <Text style={[styles.tableCell, styles.colValor]}>
                    {r.valor}
                  </Text>
                </View>
              ))}
            </>
          )}

          {/* Terapias Complementares */}
          {terapias.length > 0 && (
            <>
              <Text style={styles.sectionTitle}>Terapias Complementares</Text>
              <View style={styles.tableHeader}>
                <Text style={[styles.tableHeaderText, styles.colNome]}>
                  Nome
                </Text>
                <Text style={[styles.tableHeaderText, styles.colValor]}>
                  Valor
                </Text>
              </View>
              {terapias.map((item, i) => (
                <View key={i} style={styles.tableRow}>
                  <Text style={[styles.tableCell, styles.colNome]}>
                    {item.nome}
                  </Text>
                  <Text style={[styles.tableCell, styles.colValor]}>
                    {item.valor}
                  </Text>
                </View>
              ))}
            </>
          )}

          {/* Suplementos */}
          {suplementos.length > 0 && (
            <>
              <Text style={styles.sectionTitle}>Suplementos</Text>
              <View style={styles.tableHeader}>
                <Text style={[styles.tableHeaderText, styles.colNome]}>
                  Nome
                </Text>
                <Text style={[styles.tableHeaderText, styles.colPaciente]}>
                  Paciente
                </Text>
                <Text style={[styles.tableHeaderText, styles.colQtd]}>
                  Qtd.
                </Text>
                <Text style={[styles.tableHeaderText, styles.colUnitario]}>
                  Unitário
                </Text>
                <Text style={[styles.tableHeaderText, styles.colValor]}>
                  Valor
                </Text>
              </View>
              {suplementos.map((item, i) => (
                <View key={i} style={styles.tableRow}>
                  <Text style={[styles.tableCell, styles.colNome]}>
                    {item.nome}
                  </Text>
                  <Text style={[styles.tableCell, styles.colPaciente]}>
                    {item.paciente}
                  </Text>
                  <Text style={[styles.tableCell, styles.colQtd]}>
                    {item.qtd}
                  </Text>
                  <Text style={[styles.tableCell, styles.colUnitario]}>
                    {item.unitario}
                  </Text>
                  <Text style={[styles.tableCell, styles.colValor]}>
                    {item.valor}
                  </Text>
                </View>
              ))}
            </>
          )}

          {/* Vendas */}
          {vendas.length > 0 && (
            <>
              <Text style={styles.sectionTitle}>Vendas</Text>
              <View style={styles.tableHeader}>
                <Text style={[styles.tableHeaderText, styles.colNome]}>
                  Nome
                </Text>
                <Text style={[styles.tableHeaderText, styles.colPaciente]}>
                  Paciente
                </Text>
                <Text style={[styles.tableHeaderText, styles.colQtd]}>
                  Qtd.
                </Text>
                <Text style={[styles.tableHeaderText, styles.colUnitario]}>
                  Unitário
                </Text>
                <Text style={[styles.tableHeaderText, styles.colValor]}>
                  Valor
                </Text>
              </View>
              {vendas.map((item, i) => (
                <View key={i} style={styles.tableRow}>
                  <Text style={[styles.tableCell, styles.colNome]}>
                    {item.nome}
                  </Text>
                  <Text style={[styles.tableCell, styles.colPaciente]}>
                    {item.paciente}
                  </Text>
                  <Text style={[styles.tableCell, styles.colQtd]}>
                    {item.qtd}
                  </Text>
                  <Text style={[styles.tableCell, styles.colUnitario]}>
                    {item.unitario}
                  </Text>
                  <Text style={[styles.tableCell, styles.colValor]}>
                    {item.valor}
                  </Text>
                </View>
              ))}
            </>
          )}

          {/* Produtos Adicionais */}
          {adicionais.length > 0 && (
            <>
              <Text style={styles.sectionTitle}>Produtos Adicionais</Text>
              <View style={styles.tableHeader}>
                <Text style={[styles.tableHeaderText, styles.colNome]}>
                  Nome
                </Text>
                <Text style={[styles.tableHeaderText, styles.colQtd]}>
                  Qtd.
                </Text>
                <Text style={[styles.tableHeaderText, styles.colUnitario]}>
                  Unitário
                </Text>
                <Text style={[styles.tableHeaderText, styles.colValor]}>
                  Valor
                </Text>
              </View>
              {adicionais.map((item, i) => (
                <View key={i} style={styles.tableRow}>
                  <Text style={[styles.tableCell, styles.colNome]}>
                    {item.nome}
                  </Text>
                  <Text style={[styles.tableCell, styles.colQtd]}>
                    {item.qtd}
                  </Text>
                  <Text style={[styles.tableCell, styles.colUnitario]}>
                    {item.unitario}
                  </Text>
                  <Text style={[styles.tableCell, styles.colValor]}>
                    {item.valor}
                  </Text>
                </View>
              ))}
            </>
          )}

          {/* Totals */}
          <View style={styles.totalContainer}>
            <Text style={styles.resumoTitle}>RESUMO FINANCEIRO</Text>

            <View style={styles.pagamentoRow}>
              <Text style={styles.pagamentoLabel}>Caução</Text>
              <Text style={styles.pagamentoValue}>{caucao}</Text>
            </View>

            <View style={styles.pagamentoRow}>
              <Text style={styles.pagamentoLabel}>Total Proposta</Text>
              <Text style={styles.pagamentoValue}>{subTotal}</Text>
            </View>

            <View style={styles.pagamentoRow}>
              <Text style={styles.pagamentoLabel}>Desconto</Text>
              <Text style={styles.pagamentoValue}>{desconto}</Text>
            </View>

            <View style={styles.resumoDivider} />
            <View style={styles.totalPagarRow}>
              <Text style={styles.totalPagarLabel}>Total a Pagar</Text>
              <Text style={styles.totalPagarValue}>{total}</Text>
            </View>

            {formasPagamento.length > 0 && (
              <View style={styles.resumoDivider} />
            )}
            {formasPagamento.length > 0 && (
              <Text style={styles.formasPagamentoTitle}>
                FORMAS DE PAGAMENTO
              </Text>
            )}
            {formasPagamento.map((item, index) => (
              <View key={index} style={styles.pagamentoRow}>
                <Text style={styles.pagamentoLabel}>{item.nome}</Text>
                <Text style={styles.pagamentoValue}>
                  R$ {item.vlPago.toFixed(2).replace('.', ',')}
                </Text>
              </View>
            ))}
            <View style={styles.resumoDivider} />
            <View style={styles.totalPagarRow}>
              <Text style={styles.totalPagarLabel}>Total pago</Text>
              <Text style={styles.totalPagarValue}>
                R$ {totalPago.toFixed(2).replace('.', ',')}
              </Text>
            </View>
            {valorEstornado > 0 && (
              <>
                <View style={styles.pagamentoRow}>
                  <Text style={styles.pagamentoLabel}>Valor estornado</Text>
                  <Text style={styles.pagamentoValue}>
                    R$ {valorEstornado.toFixed(2).replace('.', ',')}
                  </Text>
                </View>
                <View style={styles.totalPagarRow}>
                  <Text style={styles.totalPagarLabel}>Valor líquido pago</Text>
                  <Text style={styles.totalPagarValue}>
                    R$ {valorPagoLiquido.toFixed(2).replace('.', ',')}
                  </Text>
                </View>
              </>
            )}
          </View>
        </View>

        {/* Footer */}
        <View style={styles.footer}>
          <Text style={styles.footerText}>
            SPA TOUR LIFE - APART HOTEL LTDA | 3Sync Sistemas
          </Text>
          <Text style={styles.footerText}>
            {`Emitido em Montenegro ${dayjs().format('DD [de] MMMM [de] YYYY')}`}
          </Text>
        </View>
      </Page>
    </Document>
  )
}
